import { NavLink, Outlet } from "react-router";

const tabClass = ({ isActive }: { isActive: boolean }) =>
  `touch-target inline-flex items-center border-b-2 px-3 py-2 font-medium ${isActive ? "border-brand text-brand" : "border-transparent text-muted"}`;

/** Settings (OD-34): admin-only tabs. Each tab is its own routed page with its own h1. */
export function Settings() {
  return (
    <div className="flex flex-col gap-6">
      <nav aria-label="Settings" className="flex flex-wrap gap-1 border-b border-line">
        <NavLink to="/settings/users" className={tabClass}>Users</NavLink>
        <NavLink to="/settings/connectors" className={tabClass}>Connectors</NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
